import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "18",
  fill: "none",
  viewBox: "0 0 18 18"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M3.583 14.417c1.667 1.666 3.959.625 4.584 0l1.25-1.25-4.584-4.584-1.25 1.25c-.625.625-1.666 2.917 0 4.584m0 0L1.5 16.5M14.417 3.583c-1.667-1.666-3.959-.625-4.584 0l-1.25 1.25 4.584 4.584 1.25-1.25c.625-.625 1.666-2.917 0-4.584m0 0L16.5 1.5M9.417 5.667 7.75 7.333m4.583 1.25-1.666 1.667"
    }, null, -1)
  ]))]))
}
export default { render: render }